import React, { useState } from 'react';
import './App.css';
import Input from './components/Input';
import Output from './components/Output';

function App() {
  const [userInput, setUserInput] = useState('');

  const onGenerateEmojifiedTextHandler = (user_raw_input) => {
    setUserInput(user_raw_input);
  };

  return (
    <div className="container">
      <h1>Emojify! 😄</h1>
      <h2> Turn your text into emojis!</h2>
      <div id='app'>
        <Input className='user-input' onGenerateEmojifiedText={onGenerateEmojifiedTextHandler} placeholder='Type here...'/>
        <Output className='emojify-output' userRawInput={userInput}/>
      </div>
      <footer>
      <p>Emojify is made with ❤️ , ☕️  and ReactJS by <a target="_blank" rel="noreferrer" href="http://matheusfreitag.github.io/">Matheus Freitag</a></p>
      <p>The background was inspired by <a target="_blank" rel="noreferrer" href="http://twitter.com/PGradients">@PGradients</a> - you should take a look!</p>
    </footer>
    </div>
  );
}

export default App;
